/**
 * Created by minghua.li on 2020/9/9.
 */
export default {
    isPC:false,
    count: 0,
    cmsData: {}
}



// WEBPACK FOOTER //
// ./src/libs/statusBus.js